import React, {useContext, useEffect, useState} from "react";
import { useCookies } from "react-cookie";
import $ from "jquery";
import DownloadFileIcon from "../../../icons/DownloadFileIcon";
import StringTools from "../../../../class/tool/StringTools";
import StatisticContext from "../../../../context/StatisticContext";

const ProductDetails = props => {
    const { parent, close } = props;
    const { statsProducts } = useContext(StatisticContext);
    const [ productsList, setProductsList ] = useState([]);
    const [ productTotal, setProductTotal ] = useState({});
    const [ cookies, setCookies ] = useCookies();
    const id = "productDetails";
    const model = {
        sorting:
            window.matchMedia('(max-width: 640px)').matches
            ? [
                { value: "quantity", title: "Qté" },
                { value: "exclTax", title: "HT" },
                { value: "inclTax", title: "TTC" }
            ]
            : [
                { value: "quantity", title: "Quantité" },
                { value: "exclTax", title: "HT" },
                { value: "inclTax", title: "TTC" },
                { value: "discount", title: "Remise" }
            ],
        table: [
            {
                name: "Nom",
                target: "metadatas",
                type: "text",
                classname: "left",
                object: "name",
                suffix: "",
                inTotal: "label"
            },
            {
                name: "Quantité",
                target: "datas",
                type: "int",
                classname: "center",
                object: "quantity",
                suffix: "",
                inTotal: "value"
            },
            {
                name: "HT",
                target: "datas",
                type: "decimal",
                classname: "right",
                object: "exclTax",
                suffix: "",
                inTotal: "value"
            },
            {
                name: "TTC",
                target: "datas",
                type: "decimal",
                classname: "right",
                object: "inclTax",
                suffix: "",
                inTotal: "value"
            },
            {
                name: "Remise",
                target: "datas",
                type: "decimal",
                classname: "right",
                object: "discount",
                suffix: "",
                inTotal: "value"
            }
        ],
        selectable: false,
        downloadable: true,
        inTotal: false
    };

    const checkCookies = () => {
        if (cookies[id + "Pref"] === undefined || Object.keys(cookies[id + "Pref"]).length === 0) {
            setCookies(id + "Pref", { sorting: "inclTax" });
        }
        else {
            const elmt = $("#" + id + "-" + cookies[id + "Pref"].sorting);

            if (elmt.length > 0) {
                $("#overlay-" + id).css({ width: elmt.innerWidth(), left: elmt.position().left });
            }
        }
    }
    const changeCookie = (name, value) => {
        setCookies(name, value);
    }
    const sortingList = () => {
        if (statsProducts === null)
            return;

        try {
            let list = [];
            let total = {};

            for (let i in model.table) {
                switch (model.table[i].inTotal) {
                    case "label":
                        total[model.table[i].object] = "Total";
                        break;
                    case "value":
                        total[model.table[i].object] = 0;
                        break;
                    default:
                        total[model.table[i].object] = "";
                        break;
                }
            }

            if (statsProducts !== null && cookies[id + "Pref"] !== undefined) {
                for (let i in statsProducts.date.period.datas) {
                    const entry = statsProducts.date.period.datas[i];
                    entry.discount = entry.inclTaxUndiscounted - entry.inclTax;

                    list.push(entry);

                    if (model.inTotal) {
                        for (let i in model.table) {
                            switch (model.table[i].inTotal) {
                                case "value":
                                    total[model.table[i].object] += entry[model.table[i].target][model.table[i].object];
                                    break;
                                default: break;
                            }
                        }
                    }
                }

                if (cookies[id + "Pref"] !== undefined) {
                    let elmtSorting = model.table.find(_ => _.object === cookies[id + "Pref"].sorting);

                    if (elmtSorting !== undefined)
                        list.sort((a, b) => b[elmtSorting.target][elmtSorting.object] - a[elmtSorting.target][elmtSorting.object]);
                }
            }

            setProductsList(list);
            setProductTotal(total);
        }
        catch (e) {}
    }
    const buildTableValue = (data, row) => {
        switch (row.type) {
            case "text": return data[row.target][row.object].length > 3 ? StringTools.capitalizeFirstLetter(data[row.target][row.object].toLowerCase()) : data[row.target][row.object] + (row.suffix.length > 0 ? " " + row.suffix : "");
            case "int": return StringTools.number_format(data[row.target][row.object], 0, ",", " ") + (row.suffix.length > 0 ? " " + row.suffix : "");
            case "decimal": return StringTools.number_format(data[row.target][row.object], 2, ",", " ") + (row.suffix.length > 0 ? " " + row.suffix : "");
            default: return data[row.target][row.object] + (row.suffix.length > 0 ? " " + row.suffix : "");
        }
    }
    const buildTotalValue = row => {
        switch (row.type) {
            case "text": return productTotal[row.object].length > 3 ? StringTools.capitalizeFirstLetter(productTotal[row.object].toLowerCase()) : productTotal[row.object] + (row.suffix.length > 0 ? " " + row.suffix : "");
            case "int": return StringTools.number_format(productTotal[row.object], 0, ",", " ") + (row.suffix.length > 0 ? " " + row.suffix : "");
            case "decimal": return StringTools.number_format(productTotal[row.object], 2, ",", " ") + (row.suffix.length > 0 ? " " + row.suffix : "");
            default: return productTotal[row.object] + (row.suffix.length > 0 ? " " + row.suffix : "");
        }
    }

    useEffect(() => {
        checkCookies();
    }, [cookies]);
    useEffect(() => {
        sortingList();
    }, [cookies, statsProducts]);

    return(
        <>
            <div className={"overlayer hover" + (parent === null ? " hidden" : "")} onClick={close} />
            <div className={"productDetails" + (parent === null ? " hidden" : "")}>
                {
                    parent !== null
                    && <>
                        <header>
                            <p className={"title"}>{ parent.datas.name.length > 3 ? StringTools.capitalizeFirstLetter(parent.datas.name.toLowerCase()) : parent.datas.name }</p>
                            <div className={"sorting"}>
                                <div id={"overlay-" + id} className={"bgOverlay"} />
                                {
                                    model.sorting.map((sorting, index) => (
                                        <p key={index} id={id + "-" + sorting.value} className={"sort" + (cookies[id + "Pref"] !== undefined && cookies[id + "Pref"].sorting === sorting.value ? " selected" : "")} onClick={() => { changeCookie(id + "Pref", { sorting: sorting.value }) }}>{ sorting.title }</p>
                                    ))
                                }
                            </div>
                            <div className={"types"}>
                                {
                                    model.downloadable
                                    && <p className={"type"}><DownloadFileIcon /></p>
                                }
                            </div>
                        </header>
                        <div className={"containerTable"}>
                            <table className={"sortingTable"}>
                                <thead>
                                    <tr>
                                    {
                                        model.table.map((row, index) => (
                                            <th key={index} className={row.classname + (cookies[id + "Pref"] !== undefined && cookies[id + "Pref"].sorting === row.object ? " selected" : "")}>{ row.name }</th>
                                        ))
                                    }
                                    </tr>
                                </thead>
                                <tbody>
                                {
                                    productsList.map((data, index) => (
                                        <tr key={index}>
                                            {
                                                model.table.map((row, index) => (
                                                    <td key={index} className={row.classname + (cookies[id + "Pref"] !== undefined && cookies[id + "Pref"].sorting === row.object ? " selected" : "")}>{ buildTableValue(data, row) }</td>
                                                ))
                                            }
                                        </tr>
                                    ))
                                }
                                {
                                    Object.keys(productTotal).length > 0
                                    && <tr className={"total"}>
                                        {
                                            model.table.map((row, index) => (
                                                <td key={index} className={row.classname + " total" + (cookies[id + "Pref"] !== undefined && cookies[id + "Pref"].sorting === row.object ? " selected" : "")}>{ buildTotalValue(row) }</td>
                                            ))
                                        }
                                    </tr>
                                }
                                </tbody>
                            </table>
                        </div>
                    </>
                }
                <div className={"containerButtons"}>
                    <button className={"close"} onClick={close}>Fermer</button>
                </div>
            </div>
        </>
    );
}

export default ProductDetails;